
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartKmWu5V0UD9i2_LrWX_45l0jioWKvCCHv_CfEEdScW1fu0Meta } from "/var/www/frontend/releases/20260716174406/pages/cart.vue?macro=true";
import { default as indexYdqCD74f_u3ZiipKoh21RMgsJuxDtZAjxBE0aHttpMUMeta } from "/var/www/frontend/releases/20260716174406/pages/index.vue?macro=true";
import { default as searchSzJdDuLQnWUvqjAH4SFwUouFn2zDazmm33z62Jz70RgMeta } from "/var/www/frontend/releases/20260716174406/pages/search.vue?macro=true";
import { default as thankslz2MRshL9FfMzuQW_8YTQUOhIF4Awy_xbkjN8Se_Cl4Meta } from "/var/www/frontend/releases/20260716174406/pages/thanks.vue?macro=true";
import { default as returnsrMinpjWIrT9W9G8PXyCVirBkyddyzdzWtQIz0DJbvYQMeta } from "/var/www/frontend/releases/20260716174406/pages/returns.vue?macro=true";
import { default as favoritesAMsPjZlyJfLk082x2u6ILC7loNhNy7gAFRXvUUqGgxoMeta } from "/var/www/frontend/releases/20260716174406/pages/favorites.vue?macro=true";
import { default as shops82LPAGctnmfLSlJx545Momfh_83DSdoA0FmZKA7pu4kMeta } from "/var/www/frontend/releases/20260716174406/pages/help/shops.vue?macro=true";
import { default as salesHWRA4G5XQrHzwapUN_3NYL2BV9hbFX847kATYAfkVzsMeta } from "/var/www/frontend/releases/20260716174406/pages/info/sales.vue?macro=true";
import { default as brands6wQMg_45TmXY3z8Su_45tp8DtEFup7zKatj_l4xRKVjzUAMeta } from "/var/www/frontend/releases/20260716174406/pages/about/brand.vue?macro=true";
import { default as constructorLc5oYBYlzpSoLZZFtAk2A0Ji6p96LnJrtVWAMRexmhkMeta } from "/var/www/frontend/releases/20260716174406/pages/constructor.vue?macro=true";
import { default as craftssisBipOALynFf4vYfQ6WLfXr8nAwFUb8RbOeAi_sd4AMeta } from "/var/www/frontend/releases/20260716174406/pages/about/crafts.vue?macro=true";
import { default as customw_0myG0D7ex07egQo8bRaJBrbxyMwdXTq24lTHughv8Meta } from "/var/www/frontend/releases/20260716174406/pages/about/custom.vue?macro=true";
import { default as authO5nD5E_45eHZtpwWu6bqxmJ2OEj9EiPUo_45fuxNIzqWR00Meta } from "/var/www/frontend/releases/20260716174406/pages/cabinet/auth.vue?macro=true";
import { default as menuXgwrYspNpCyuQBWMMXgfggJj5grRcYHdiKjM_AdeVfYMeta } from "/var/www/frontend/releases/20260716174406/pages/catalog/menu.vue?macro=true";
import { default as centersS6gfJqyLBJx9rSCwyKzej0awrhJoSICALXqTKl1fWBkMeta } from "/var/www/frontend/releases/20260716174406/pages/help/centers.vue?macro=true";
import { default as service6TOXwj8nQ7ZAWjw719JskRkkTxYqlgKekZA7t9AoSGoMeta } from "/var/www/frontend/releases/20260716174406/pages/help/service.vue?macro=true";
import { default as _91_46_46_46catchAll_93QtSBMDwAnYJ_45iyNBMjDz10nNVyMRRXopz0xcx3fZj8sMeta } from "/var/www/frontend/releases/20260716174406/pages/[...catchAll].vue?macro=true";
import { default as historyiE8PlClph9_45CJ82ZKmxy81yOySAm6VRrTAB_kXQ9DN0Meta } from "/var/www/frontend/releases/20260716174406/pages/about/history.vue?macro=true";
import { default as indexh_HGSgIfVdqsP27yQJiKxaJBmNIyvTnrcxpPbfoTqN8Meta } from "/var/www/frontend/releases/20260716174406/pages/cabinet/index.vue?macro=true";
import { default as indexfTiqBNSu6ViO4bAAS4QJwOfE1NrBdYctjgGbpiFd_45X4Meta } from "/var/www/frontend/releases/20260716174406/pages/catalog/index.vue?macro=true";
import { default as contactst8oErEdCOnJu7bplB4jKxSILr9GyrlhdVTscwJx0avQMeta } from "/var/www/frontend/releases/20260716174406/pages/help/contacts.vue?macro=true";
import { default as delivery5pcW49SoxOb_g1Btfsu2qBVZ2sTeg0hrN7FKjFiwoKcMeta } from "/var/www/frontend/releases/20260716174406/pages/help/delivery.vue?macro=true";
import { default as warranty09e2BzI3EQVLnCkliWwYspM21tEElUql0IZ2oiIb2q4Meta } from "/var/www/frontend/releases/20260716174406/pages/help/warranty.vue?macro=true";
import { default as cashbackqNXbZyn_YXVVychtgn6FMxxvJnlnIZ4yajjFDP0_whAMeta } from "/var/www/frontend/releases/20260716174406/pages/info/cashback.vue?macro=true";
import { default as indexLNrzcr04D_y9O55p7KDVfrdDbzvVKpEaIjrGwKDwAx8Meta } from "/var/www/frontend/releases/20260716174406/pages/checkout/index.vue?macro=true";
import { default as accountHee6_0ZRzGtqh7ww0l8IDMkjstQGfVD8846ncmOUM_45EMeta } from "/var/www/frontend/releases/20260716174406/pages/cabinet/account.vue?macro=true";
import { default as processingttLW7poDexuokVPuFTX4WKz2ZQF5PW2nGMf_45Xgdf6iYMeta } from "/var/www/frontend/releases/20260716174406/pages/info/processing.vue?macro=true";
import { default as principles4Yuqi6lpUuyOxjC70JEcs7Hre3nIW0WqNmm51EFBUyQMeta } from "/var/www/frontend/releases/20260716174406/pages/about/principles.vue?macro=true";
import { default as cooperationKjRWXYyexck7CfaVjegGhpbyrIisEDko_Tka85Lt43EMeta } from "/var/www/frontend/releases/20260716174406/pages/about/cooperation.vue?macro=true";
import { default as _91catalog_93gkRJxFEiwbCvgVwBz_456Y_N8MKirnW2JQbZGyRviMnDwMeta } from "/var/www/frontend/releases/20260716174406/pages/catalog/[catalog].vue?macro=true";
import { default as _91product_93y98MTPFmjH2zsPtEfNcNq7ZH4UGlZzDd3YYcg8bHu_8Meta } from "/var/www/frontend/releases/20260716174406/pages/product/[product].vue?macro=true";
import { default as price_45listtuzFZRaxCIpFg_45Wy1GVtY2z8rKUSZNG_45fknFmPK0tL8Meta } from "/var/www/frontend/releases/20260716174406/pages/cabinet/price-list.vue?macro=true";
import { default as indexz5Io9LMdyHCYOe6oowELGDvJIF25dbrcXWEUBbAUeNoMeta } from "/var/www/frontend/releases/20260716174406/pages/cabinet/orders/index.vue?macro=true";
import { default as _91order_93zTt9W5FeHDMeaM8WGYEwLZhL3WAoSmGjtoCuFhrK8bwMeta } from "/var/www/frontend/releases/20260716174406/pages/cabinet/orders/[order].vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/cart.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/search.vue")
  },
  {
    name: "Спасибо за заказ",
    path: "/thanks",
    meta: thankslz2MRshL9FfMzuQW_8YTQUOhIF4Awy_xbkjN8Se_Cl4Meta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/thanks.vue")
  },
  {
    name: "returns",
    path: "/returns",
    meta: returnsrMinpjWIrT9W9G8PXyCVirBkyddyzdzWtQIz0DJbvYQMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/returns.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/favorites.vue")
  },
  {
    name: "help-shops",
    path: "/help/shops",
    meta: shops82LPAGctnmfLSlJx545Momfh_83DSdoA0FmZKA7pu4kMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/help/shops.vue")
  },
  {
    name: "info-sales",
    path: "/info/sales",
    meta: salesHWRA4G5XQrHzwapUN_3NYL2BV9hbFX847kATYAfkVzsMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/info/sales.vue")
  },
  {
    name: "about-brand",
    path: "/about/brand",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/about/brand.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/constructor.vue")
  },
  {
    name: "about-crafts",
    path: "/about/crafts",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/about/crafts.vue")
  },
  {
    name: "about-custom",
    path: "/about/custom",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/about/custom.vue")
  },
  {
    name: "auth",
    path: "/cabinet/auth",
    meta: authO5nD5E_45eHZtpwWu6bqxmJ2OEj9EiPUo_45fuxNIzqWR00Meta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/cabinet/auth.vue")
  },
  {
    name: "catalog-menu",
    path: "/catalog/menu",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/catalog/menu.vue")
  },
  {
    name: "help-centers",
    path: "/help/centers",
    meta: centersS6gfJqyLBJx9rSCwyKzej0awrhJoSICALXqTKl1fWBkMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/help/centers.vue")
  },
  {
    name: "help-service",
    path: "/help/service",
    meta: service6TOXwj8nQ7ZAWjw719JskRkkTxYqlgKekZA7t9AoSGoMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/help/service.vue")
  },
  {
    name: "catchAll",
    path: "/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_93QtSBMDwAnYJ_45iyNBMjDz10nNVyMRRXopz0xcx3fZj8sMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/[...catchAll].vue")
  },
  {
    name: "История",
    path: "/about/history",
    meta: historyiE8PlClph9_45CJ82ZKmxy81yOySAm6VRrTAB_kXQ9DN0Meta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/about/history.vue")
  },
  {
    name: "cabinet",
    path: "/cabinet",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/cabinet/index.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/catalog/index.vue")
  },
  {
    name: "help-contacts",
    path: "/help/contacts",
    meta: contactst8oErEdCOnJu7bplB4jKxSILr9GyrlhdVTscwJx0avQMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/help/contacts.vue")
  },
  {
    name: "help-delivery",
    path: "/help/delivery",
    meta: delivery5pcW49SoxOb_g1Btfsu2qBVZ2sTeg0hrN7FKjFiwoKcMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/help/delivery.vue")
  },
  {
    name: "help-warranty",
    path: "/help/warranty",
    meta: warranty09e2BzI3EQVLnCkliWwYspM21tEElUql0IZ2oiIb2q4Meta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/help/warranty.vue")
  },
  {
    name: "info-cashback",
    path: "/info/cashback",
    meta: cashbackqNXbZyn_YXVVychtgn6FMxxvJnlnIZ4yajjFDP0_whAMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/info/cashback.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/checkout/index.vue")
  },
  {
    name: "Мой профиль",
    path: "/cabinet/account",
    meta: accountHee6_0ZRzGtqh7ww0l8IDMkjstQGfVD8846ncmOUM_45EMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/cabinet/account.vue")
  },
  {
    name: "info-processing",
    path: "/info/processing",
    meta: processingttLW7poDexuokVPuFTX4WKz2ZQF5PW2nGMf_45Xgdf6iYMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/info/processing.vue")
  },
  {
    name: "about-principles",
    path: "/about/principles",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/about/principles.vue")
  },
  {
    name: "about-cooperation",
    path: "/about/cooperation",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/about/cooperation.vue")
  },
  {
    name: "catalog-catalog",
    path: "/catalog/:catalog(.*-\\d+)",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/catalog/[catalog].vue")
  },
  {
    name: "product-product",
    path: "/product/:product()",
    component: () => import("/var/www/frontend/releases/20260716174406/pages/product/[product].vue")
  },
  {
    name: "Прайс-лист",
    path: "/cabinet/price-list",
    meta: price_45listtuzFZRaxCIpFg_45Wy1GVtY2z8rKUSZNG_45fknFmPK0tL8Meta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/cabinet/price-list.vue")
  },
  {
    name: "Мои заказы",
    path: "/cabinet/orders",
    meta: indexz5Io9LMdyHCYOe6oowELGDvJIF25dbrcXWEUBbAUeNoMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/cabinet/orders/index.vue")
  },
  {
    name: "Заказ",
    path: "/cabinet/orders/:order()",
    meta: _91order_93zTt9W5FeHDMeaM8WGYEwLZhL3WAoSmGjtoCuFhrK8bwMeta || {},
    component: () => import("/var/www/frontend/releases/20260716174406/pages/cabinet/orders/[order].vue")
  }
]